export default __webpack_public_path__ + "static/media/AlgebraTableImg2.631c9ed7.PNG";